module.exports = __webpack_public_path__ + "img/3d-desktop_cn.b9decda.jpg";